module.exports = __webpack_public_path__ + "img/leftArrow.ae186d8c.gif";